import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import store, { persistor } from './store'

ReactDOM.render(
  <Provider store={store}>
    {/* PersistGate holds rendering until persisted state is rehydrated from localStorage.
        loading={null} means nothing is shown during rehydration (instant on fast devices). */}
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
)
